import React, { useEffect, useRef, useState } from 'react'
import '../styles/Auth.css'
import logo from "../imgs/logo.png"
import API from '../APIs/AdminApi'
import { useNavigate } from 'react-router-dom'

const Auth = ({setCookie, cookies, setAdminData}) => {

  const navigate = useNavigate()

  const inputRef = useRef(null)

  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    if(cookies?.adminData?.login || cookies?.adminData?.password) navigate('/');
  }, [])

  const [login, setLogin] = useState("")
  const [password, setPassw] = useState("")

  const adminSignUp = () => {
    let adminData = {
      login: login,
      password: password
    }
    API.LoadAdmin(adminData).then((data) => {
      // console.log(data);
      if(data.status == 200){
        setAdminData(data.res.data)
        setCookie('adminData', {_id: data.res.data._id, login: data.res.data.login, password: data.res.data.password}, {path: '/'})
        navigate('/')
      }
    }).catch((e) => {
      console.error(e)
    })
  }
  return (
    <div className='authCont'>
        <div className="authCard">
            <div className="authCardBg">
                <div className="authCardCont">
                    <div className="topauth">
                      <h1>Вход</h1>
                      <img src={logo} alt="logo" />
                    </div>
                    <input className='authInput' type="text" placeholder='Логин' value={login} onChange={(e) => setLogin(e.target.value)} onKeyDown={(e) => e.key == 'Enter' ? handleButtonClick() : null}/>
                    <input className='authInput' 
                      ref={inputRef} 
                      type="password" 
                      placeholder='Пароль' 
                      value={password} 
                      onChange={(e) => setPassw(e.target.value)} 
                      onKeyDown={(e) => e.key == 'Enter' ? (login.length !== 0 && password.length !== 0) ? adminSignUp() : null : null}
                    />
                    <div className="buttonCont">
                      <button className='admButton' disabled={login.length !== 0 && password.length !== 0 ? false : true} onClick={() => adminSignUp()}>Вход</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Auth